<div class="ui buttons button-container">
    <ng-container *ngFor="let interval of intervals">
        <button
            class="ui attached basic secondary button"
            [class.hide-on-mobile]="interval.value === 'next 3 weeks'"
            [ngClass]="{
                'interval-button-selected': interval.label === wizardService.quickDates?.label
            }"
            (click)="handleSelectInterval(interval)"
        >
            {{ interval.label }}
        </button>
    </ng-container>
    <div class="ui icon top left pointing dropdown basic secondary--expanded button" #buttonDropdown>
        <i class="ellipsis vertical icon"></i>
        <div class="menu">
            <ng-container *ngFor="let interval of additionalIntervals">
                <div
                    class="item"
                    [class.show-on-mobile]="interval.value === 'next 3 weeks'"
                    (click)="handleSelectInterval(interval)"
                >
                    {{ interval.label }}
                </div>
            </ng-container>
        </div>
    </div>
</div>
